import DisplayItems from '../../methods/displayItems/DisplayItems';
import GalleryCart from './GalleryCard';
import { galleries } from './images';
export default function Gallery(second) {
  return <DisplayItems items={galleries} View={GalleryCart} center />;
}
